var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9314814,0.678868484 C17.1466861,0.182962051 17.6893762,-0.0930613406 18.2180311,0.0285760863 L23.0835282,1.1513831 C23.5934697,1.26834217 23.9537037,1.72214334 23.9537037,2.24611995 C23.9537037,14.2461199 14.2273879,23.9537223 2.24610132,23.9537223 C1.71744635,23.9537223 1.26832355,23.58881 1.15136448,23.0835468 L0.0285574641,18.2180498 C-0.0930799628,17.6893948 0.182943429,17.1467047 0.683528224,16.9268217 L5.92329431,14.6812077 C6.38177384,14.4847164 6.91510717,14.6157106 7.23323583,15.0040147 L9.55370366,17.8391024 C13.2168616,16.1221433 16.1595516,13.137348 17.8437621,9.54904392 L15.0086744,7.22857609 C14.6203703,6.91512579 14.4893762,6.3771141 14.6858674,5.91863457 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.0 0.0) scale(-1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.04629633705163272 0.04627771487594856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.11022302e-16,3.46944695e-18 23.9537037,3.46944695e-18 23.9537037,23.9537223 -1.11022302e-16,23.9537223 -1.11022302e-16,3.46944695e-18",
    stroke: "none",
    fill: "#14695D"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phoneNumber.0cf730b2b6028e4507be796c096ec48d.svg";
export { ForwardRef as ReactComponent };